import { FrontElementMetadata } from "../Metadata/FrontMetadata";

export class VerticalSplit {
    

    constructor(public Top: number, public Bottom: number, public FrontElement: FrontElementMetadata | null, public IsGroove: boolean) {}
}
